import { EveryDayLowPriceImage } from "./components/image/image.container";
import { Base } from "./everyDayLowPrice.base";

export const EveryDayLowPrice = Object.assign(Base, {
    Image: EveryDayLowPriceImage
});
